import { app } from '../../app';
import { Controller } from './public.controller';

app.component('public', {
    controller: Controller,
    templateUrl: require('./public.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/public.component.js